<template>
  <svg width="24" height="27" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22L19 15L12 8" stroke="#6782F6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 15L19 15" stroke="#6782F6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>